import { businessService } from '@/pages/Business/services/business.service';

export interface ArrivalScanTransition {
  transitionId: string;
  success: boolean;
  reason?: string;
}

export interface ArrivalScanFinalStatus {
  id: string;
  name: string;
  commercialName: string | null;
}

export interface ArrivalScanResponse {
  shippingNumber: number;
  locationIdChanged: boolean;
  locationId: string;
  transitions: ArrivalScanTransition[];
  transitionsApplied: number;
  transitionsFailed: number;
  finalStatus: ArrivalScanFinalStatus | null;
}

const arrivalScanApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    processArrivalScan: builder.mutation<
      ArrivalScanResponse,
      { code: string; mode?: 'NUMBER' | 'COMMERCIAL_NUMBER' }
    >({
      query: ({ code, mode }) => ({
        url: `/ascan/process/${code}`,
        method: 'POST',
        params: { ...(mode && { mode }) },
      }),
      invalidatesTags: ['ArrivalScan'],
    }),
  }),
  overrideExisting: false,
});

export const { useProcessArrivalScanMutation } = arrivalScanApi;
